import ColorWrapper, {
  Props as ColorWrapperProps,
} from "Components/ColorWrapper";
import {
  CardContent,
  DescriptionWrapper,
  IconWrapper,
  Title,
} from "./insuranceAdviceCardStyled";

import Box from "@storeblocks/box";
import { ProductType } from "Store/interfaces/products/checkout/ProductType";
import { ProductIcon } from "Utils/icons";
import { getProductName } from "Utils/nameUtils/nameUtils";
import React from "react";

interface Props extends Pick<ColorWrapperProps, "space" | "padding"> {
  product: ProductType;
  title: string;
}

export const InsuranceAdviceCard = ({
  product,
  title,
  space,
  children,
}: React.PropsWithChildren<Props>): React.ReactElement => {
  return (
    <ColorWrapper dynamicInsuranceDetailsCard selected={false} space={space}>
      <Box display="flex">
        <IconWrapper className="svg" background="transparent">
          <ProductIcon product={product} label={getProductName(product)} />
        </IconWrapper>
        <CardContent>
          <Title>{title}</Title>
          <DescriptionWrapper>{children}</DescriptionWrapper>
        </CardContent>
      </Box>
    </ColorWrapper>
  );
};
